import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Drawer } from "antd";
import { getToken, handleLogout, isLoggedIn } from "../utils/utils";

const Sidebar = ({ isDrawerOpen, toggleDrawer }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(navigate)
  // useEffect(() => {
  //   console.log(isLoggedIn())
  //   !isLoggedIn() && navigate("/login");
  // }, []);
  return (
    <>
      <div className="sidebar-main-container">
        <div className="sidebar-logo-container h-center">
          {/* <img src="../../assets/images/logo.png" alt="logo" className="logo" /> */}
          <h4 className="text-white">AI powered doc</h4>
        </div>
        <div className="sidebar-options-container">
          <ul className="d-flex flex-column space-between">
            <div className="top-options">
              <li>
                <NavLink
                  to="/dashboard/fileupload"
                  className={`dashLinks d-flex ${
                    location.pathname === "/dashboard/fileclassification"
                      ? "active"
                      : ""
                  } `}
                >
                  <Icon
                    icon="mdi:text-box-search"
                    width={25}
                    height={28}
                    className={`sidebar-icons ${
                      location.pathname === "/dashboard/fileclassification"
                        ? "active"
                        : ""
                    }`}
                  />
                  <label
                    className={`elarge cursor-pointer ${
                      location.pathname === "/dashboard/fileclassification"
                        ? "active"
                        : ""
                    }`}
                  >
                    Documents
                  </label>
                </NavLink>
              </li>
              <li>
                <NavLink to="/finding" className="dashLinks d-flex">
                  <img
                    src="../../assets/icons/findings.svg"
                    alt="option"
                    className="sidebar-img cursor-pointer"
                  />
                  <label className="elarge cursor-pointer">Findings</label>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/keywords"
                  className="dashLinks d-flex"
                  activeClassName="active"
                >
                  <Icon
                    icon="streamline:layers-1-solid"
                    width={24}
                    height={24}
                    className="sidebar-icons"
                  />
                  <label className="elarge cursor-pointer">Keywords</label>
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to="/settings"
                  className="dashLinks d-flex"
                  activeClassName="active"
                >
                  <Icon
                    icon="uil:setting"
                    width={24}
                    height={24}
                    className="sidebar-icons"
                  />
                  <label className="elarge cursor-pointer">Settings</label>
                </NavLink>
              </li>
            </div>
            <div className="bottom-options">
              <li
                className="dashLink-logout d-flex"
                onClick={() => {
                  handleLogout();
                  window.location.href ="/login";
                }}
              >
                <Icon
                  icon="tabler:logout"
                  width={24}
                  height={24}
                  className="sidebar-icons cursor-pointer"
                />
                <label className="elarge cursor-pointer">Logout</label>
              </li>
            </div>
          </ul>
        </div>
      </div>
      <div className="mobile-sidebar d-none">
        <Drawer
          placement="left"
          closable={false}
          onClose={toggleDrawer}
          open={isDrawerOpen}
          className="mobile-menu-drawer"
        >
          <div className="sidebar-container">
            <div className="sidebar-logo-container h-center">
              {/* <img
                src="../../assets/images/logo.png"
                alt="logo"
                className="logo"
              /> */}
              <h4 className="text-white">AI powered doc</h4>
              <img
                src="../../assets/icons/backArrow.png"
                alt="logo"
                className="backarrow-Logo"
                onClick={toggleDrawer}
              />
            </div>
            <div className="sidebar-options-container">
              <ul className="d-flex flex-column space-between">
                <div className="top-options">
                  <li>
                    <NavLink
                      to="/dashboard/fileupload"
                      className={`dashLinks d-flex ${
                        location.pathname === "/dashboard/fileclassification"
                          ? "active"
                          : ""
                      } `}
                      onClick={toggleDrawer}
                    >
                      <Icon
                        icon="mdi:text-box-search"
                        width={25}
                        height={28}
                        className={`sidebar-icons ${
                          location.pathname === "/dashboard/fileclassification"
                            ? "active"
                            : ""
                        }`}
                      />
                      <label
                        className={`elarge cursor-pointer ${
                          location.pathname === "/dashboard/fileclassification"
                            ? "active"
                            : ""
                        }`}
                      >
                        Documents
                      </label>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/finding"
                      className="dashLinks d-flex"
                      onClick={toggleDrawer}
                    >
                      <img
                        src="../../assets/icons/findings.svg"
                        alt="option"
                        className="sidebar-img cursor-pointer"
                      />
                      <label className="elarge cursor-pointer">Findings</label>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      to="/keywords"
                      className="dashLinks d-flex"
                      activeClassName="active"
                      onClick={toggleDrawer}
                    >
                      <Icon
                        icon="streamline:layers-1-solid"
                        width={24}
                        height={24}
                        className="sidebar-icons"
                      />
                      <label className="elarge cursor-pointer">Keywords</label>
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      to="/settings"
                      className="dashLinks d-flex"
                      onClick={toggleDrawer}
                    >
                      <Icon
                        icon="uil:setting"
                        width={24}
                        height={24}
                        className="sidebar-icons"
                      />
                      <label className="elarge cursor-pointer">Settings</label>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      to="/template"
                      className="dashLinks d-flex"
                      onClick={toggleDrawer}
                    >
                      <Icon
                        icon="fluent:calendar-template-32-filled"
                        width={24}
                        height={24}
                        className="sidebar-icons"
                      />
                      <label className="elarge cursor-pointer">Template</label>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/preset"
                      className="dashLinks d-flex"
                      onClick={toggleDrawer}
                    >
                      <Icon
                        icon="fa6-solid:file"
                        width={24}
                        height={24}
                        className="sidebar-icons"
                      />
                      <label className="elarge cursor-pointer">Preset</label>
                    </NavLink>
                  </li> */}
                </div>
                <div className="bottom-options">
                  <li>
                    <NavLink
                      to="/login"
                      className="dashLinks d-flex"
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      <Icon
                        icon="tabler:logout"
                        width={24}
                        height={24}
                        className="sidebar-icons"
                      />
                      <label className="elarge cursor-pointer">Logout</label>
                    </NavLink>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default Sidebar;
